// @ts-nocheck
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import NavMenu from './layout/NavMenu';
import LeftMenu from './layout/LeftMenu';
import { toggleNavMenu, closeNavMenu } from '../actions/layoutActions';
import OffCanvasMenu from './layout/OffCanvasMenu';
import { getKeyProviders } from '../actions/keyProviderActions';
import { getPlatforms } from '../actions/platformActions';
import { hasAnyPermission } from './auth/authUtils';
import permissionTypes from '../constants/permissionTypes';
import i18n from 'i18next';

import SlidingPane from 'react-sliding-pane';
import Complete from './requests/slideout/Complete';
import AnnouncementModal from './layout/AnnouncementModal';
import { useTranslation } from 'react-i18next';
import { fetchCompanies } from '../reducers/companyReducer';
import { useAppDispatch, useAppSelector } from '../hooks';
import { fetchAnnouncements } from '../reducers/announcementReducer';
import { getBasket } from '../reducers/basketReducer';
import { getAllCompanyTypes } from '../reducers/companyTypeReducer';

function Layout({
  children,
  toggleNavMenu,
  closeNavMenu,
  navMenuOpen,
  classes,
  completeRequestSlideoutOpen,
  setCompleteRequestSlideoutOpen,
  keyProviders,
  getKeyProviders,
  platforms,
  getPlatforms,
}) {
  const companies = useAppSelector((state) => state.companies);
  const currentUser = useAppSelector((state) => state.auth);
  const basket = useAppSelector((state) => state.basket);
  const announcements = useAppSelector((state) => state.announcements);
  const companyTypes = useAppSelector((state) => state.companyTypes);

  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    if (!basket && currentUser && !currentUser.isLoading) {
      dispatch(getBasket()).catch(() => {
        console.error(t('Failed to get basket'));
      });
    }
  }, [basket, currentUser, t, dispatch]);

  //company types
  useEffect(() => {
    if (hasAnyPermission(currentUser, [permissionTypes.MANAGE_COMPANIES])) {
      if (!companyTypes && currentUser && !currentUser.isLoading) {
        dispatch(getAllCompanyTypes())
          .unwrap()
          .catch((e) => {
            toast.error(t('Failed to get company types'));
          });
      }
    }
  }, [companyTypes, currentUser, t, dispatch]);

  useEffect(() => {
    if (currentUser) {
      i18n.changeLanguage(currentUser.language);
    }
  }, [currentUser]);

  useEffect(() => {
    if (!companies) {
      dispatch(fetchCompanies());
    }
  }, [companies, dispatch]);

  useEffect(() => {
    if (!keyProviders) {
      getKeyProviders().catch(() => {});
    }
  }, [keyProviders, getKeyProviders]);

  useEffect(() => {
    if (!platforms) {
      getPlatforms().catch(() => {});
    }
  }, [platforms, getPlatforms]);
  const actionBarOpen =
    document.getElementById('layout-action-bar')?.children?.length > 0;

  useEffect(() => {
    if (!announcements) {
      dispatch(fetchAnnouncements());
    }
  }, [announcements, dispatch]);

  return (
    <div
      id="page"
      className={`page ${navMenuOpen ? 'off-canvas-open' : ''} ${
        actionBarOpen ? 'action-bar-open' : ''
      }`}
    >
      <header id="header">
        <NavMenu
          currentUser={currentUser}
          basket={basket}
          companyTypes={companyTypes}
          toggleNavMenu={toggleNavMenu}
          setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
        />
      </header>
      <LeftMenu currentUser={currentUser} companyTypes={companyTypes} />
      <main className="page__region page__region--main">
        <div className="content-header">
          <div className="action-bar text-right" id="layout-action-bar"></div>
        </div>
        <div
          className={`container-fluid container-xs-flush d-flex flex-column pt-4 ${classes}`}
        >
          {children}
        </div>
      </main>
      <div className={`panel-overlay`}></div>
      <OffCanvasMenu
        currentUser={currentUser}
        companyTypes={companyTypes}
        basket={basket}
        closeNavMenu={closeNavMenu}
        setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
      />
      <SlidingPane
        isOpen={completeRequestSlideoutOpen}
        hideHeader={true}
        from="right"
        className="xlarge-side-panel"
        onRequestClose={() => setCompleteRequestSlideoutOpen(false)}
      >
        <Complete
          done={() => setCompleteRequestSlideoutOpen(false)}
          cancel={() => setCompleteRequestSlideoutOpen(false)}
        />
      </SlidingPane>
      {announcements && <AnnouncementModal announcements={announcements} />}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    navMenuOpen: state.navMenuOpen,
    keyProviders: state.keyProviders,
    platforms: state.platforms,
  };
}

const mapDispatchToProps = {
  toggleNavMenu,
  closeNavMenu,
  getKeyProviders,
  getPlatforms,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
